import React from "react";
import {Alert} from "antd";
import {useTranslation} from "react-i18next";
import {useQuery} from "@apollo/client";
import {PersonSpeciality} from "../backend/entity/study/PersonSpeciality";
import {SELECT_SPECIALITIES_WITH_ELECTIVE_COURSES_BY_PERSON_ID} from "../backend/service/GridService";
import ElectiveChoiceCollapse from "../components/ElectiveChoiceCollapse";
import Loading from "../components/Loading";
import {Choice} from "../backend/entity/elective/Choice";
import {
    CHOICES_ENABLED,
    ELECTIVE_SUMMER_SEMESTER,
    HOW_MANY_FUTURE_SEMESTERS,
    YEAR_SEMESTER_ID
} from "../config/season";

interface ElectiveChoiceViewProps {
    person_id: number
}

export default function ElectiveChoiceView({person_id}: ElectiveChoiceViewProps) {
    const {t} = useTranslation();

    const {
        loading,
        error,
        data
    } = useQuery<{
        grid_elective_choice: Choice[],
        study_person_speciality: PersonSpeciality[]
    }>(SELECT_SPECIALITIES_WITH_ELECTIVE_COURSES_BY_PERSON_ID, {
        pollInterval: 0,
        fetchPolicy: "no-cache",
        variables: {
            person_id: person_id,
            year_semester_id: YEAR_SEMESTER_ID,
            elective_summer_semester: ELECTIVE_SUMMER_SEMESTER
        }
    })
    if (loading) return <Loading/>
    if (error) return <p>{t('elective_choice.error')}</p>

    if (data) {
        const choicesGloballyDisabled = !CHOICES_ENABLED
        const areChoicesDisabledForStudent = choicesGloballyDisabled || data.study_person_speciality.length === 0

        return (
            <>
                {choicesGloballyDisabled &&
                    <Alert type="warning"
                           showIcon
                           message={t('elective_choice.save_disabled_popover')}
                           style={{marginBottom: 16}}/>}
                <ElectiveChoiceCollapse study_person_speciality={data.study_person_speciality}
                                        areChoicesDisabled={areChoicesDisabledForStudent}
                                        elective_choice={data.grid_elective_choice}
                                        yearSemesterId={YEAR_SEMESTER_ID}
                                        howManyFutureSemesters={HOW_MANY_FUTURE_SEMESTERS}/>
            </>
        )
    }
    return (
        <div>{t('elective_choice.error')}</div>
    )
}